import React from "react";
import "antd/dist/reset.css";
import "./App.css";

// Import Routes
import Router from "./routes";

const App = () => (
  <>
    <Router />
  </>
);

export default App;
